import React from 'react';
import { useParams } from 'react-router-dom';
import EntityUserRoleAssignmentsPage from '@features/user/pages/EntityUserRoleAssignmentsPage';

const ChurchUserRoleAssignmentsPage: React.FC = () => {
  const { churchId } = useParams<{ churchId: string }>();
  return (
    <EntityUserRoleAssignmentsPage
      scope="CHURCH"
      scopeRefId={Number(churchId)}
      title="Church - User role assignments"
      subtitle="Role assignments at this church"
      workplaceNoun="church"
      testId="church-user-role-assignments-search"
    />
  );
};

export default ChurchUserRoleAssignmentsPage;
